import { StyleButtonContained } from './styles'
import { ButtonContainedProps } from './types'

export default function ButtonContained({
  size,
  text,
  onClick
}: ButtonContainedProps) {
  return (
    <>
      <StyleButtonContained variant="contained" size={size} onClick={onClick}>
        {text}
      </StyleButtonContained>
    </>
  )
}
